var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "84px",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons - Outline/Status indicators/error-circle/2px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,8.41666667 C72.9658408,8.41666667 91.5833333,27.0341592 91.5833333,50 C91.5833333,72.9658408 72.9658408,91.5833333 50,91.5833333 C27.0341592,91.5833333 8.41666667,72.9658408 8.41666667,50 C8.41666667,27.0341592 27.0341592,8.41666667 50,8.41666667 Z M50,12.4166667 C29.2432982,12.4166667 12.4166667,29.2432982 12.4166667,50 C12.4166667,70.7567018 29.2432982,87.5833333 50,87.5833333 C70.7567018,87.5833333 87.5833333,70.7567018 87.5833333,50 C87.5833333,29.2432982 70.7567018,12.4166667 50,12.4166667 Z M50,20.9166667 C51.1045695,20.9166667 52,21.8120972 52,22.9166667 L52,22.9166667 L52,48 L77.0833333,48 C78.1879028,48 79.0833333,48.8954305 79.0833333,50 C79.0833333,51.1045695 78.1879028,52 77.0833333,52 L77.0833333,52 L50,52 C48.8954305,52 48,51.1045695 48,50 L48,50 L48,22.9166667 C48,21.8120972 48.8954305,20.9166667 50,20.9166667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Forgot-password",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forgot-password_Pending-registration",
    transform: "translate(-147.000000, -108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83E\\uDDE9-Templates/Dialogs/Mobile/Error/1-CTA/1-line-heading",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(15.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/...More/Miscellaneous/clock-or-timed/4px-colour-mask",
    transform: "translate(123.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colours/Black-|-#000000",
    mask: "url(#mask-2)",
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/ClockIcon.b7057d2596f0c6a5f30401524991a7e3.svg";
export { ForwardRef as ReactComponent };